"use client";
import React, { useEffect } from "react";
import Product from "./Product";
import { Product as ProductType } from "@/types";
import Heading from "../ui/Heading";
import { cleanUrl } from "@/helpers/Functions/TopLevel";
import Link from "next/link";
const ProductSection = (props: { products: ProductType[] }) => {
  return (
    <section className="w-[94%] max-w-[1440px] mx-auto flex flex-col justify-center items-center gap-8 py-8">
      <Heading text="Best Selling Drinks" />
      <div className="row flex flex-wrap justify-center gap-4 w-full">
        {props.products.filter((product) =>
          (product.category != "Premix") && product.outofstock != 1
        ).slice(0, 6).map((product) => {
          return (
            <Product key={product.id} product={product} image={cleanUrl(product.imageurl)} />
          )
        })}
      </div>

      <div className="flex justify-center items-center lg:self-end self-center">
        <Link href="/products" className="text-white bg-amber-500 p-2 rounded-lg mr-4"
        >Shop Now</Link>
        <Link href="/menu.pdf" target='_blank' className="text-white bg-red-900 p-2 rounded-lg"
        >View Full Menu</Link>
      </div>
    </section>
  );
};

export default ProductSection;
